import { useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { NotificationContext } from "@common/components/Notification";
import { useAuthenticatedUser } from "@services/user/hooks/useAuthenticatedUser";
import { hasNoPermissionToViewPage } from "./helpers/hasNoPermissionToViewPage";

const RouteAccessChecker = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [user] = useAuthenticatedUser();
  const { dispatchNotification } = useContext(NotificationContext);

  useEffect(() => {
    if (user && hasNoPermissionToViewPage(pathname, user)) {
      navigate(-1);

      dispatchNotification({
        message: t("You are not authorized to access this page"),
        title: t("Error"),
        duration: 3000,
      });
    }
  }, [pathname]);

  return null;
};

export default RouteAccessChecker;
